<template>
    <div>
        <CCard v-if="useFilter" class="p-1">
            <CCardBody>
                <CRow>
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="showFilters"
                        class="ml-3" />
                    <span class="ml-2">Фильтры</span>
                </CRow>
                <template v-if="showFilters">
                    <CCard class="mt-4">
                        <CCardBody>
                            <CRow>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Пользователи
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1">
                                    <CInput
                                        v-model="filter.phone"
                                        placeholder="Поиск по телефону"
                                        class="mb-0"/>
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 mb-1 d-flex align-items-center">
                                    <div class="d-flex align-items-center">
                                        <CSwitch
                                            color="dark"
                                            shape="pill"
                                            variant="opposite"
                                            :checked.sync="filter.deleted"/>
                                        <span class="ml-2">Показать удаленных</span>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>

                    <!-- Фильтры по данным о пользователе -->
                    <CCard class="mt-4">
                        <CCardBody>
                            <div class="mt-2">
                                <b>Фильтры по данным о пользователе</b>
                            </div>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Дата регистрации пользователя
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.created_at.from"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="от" />
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.created_at.to"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="до" />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Дата последнего захода в приложение
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.last_visit.from"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="от" />
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.last_visit.to"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="до" />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Установлена версия приложения
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <CInput
                                        v-model="filter.version_app.from"
                                        placeholder="от"
                                        class="mb-0 w-full"/>
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <CInput
                                        v-model="filter.version_app.to"
                                        placeholder="до"
                                        class="mb-0 w-full"/>
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Пол
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8"
                                    class="mt-1 d-flex align-items-center">
                                    <CSelect
                                        :value.sync="filter.gender"
                                        :horizontal="true"
                                        :options="genderOptions"
                                        placeholder="Выберите пол"
                                        class="custom-filter-select w-full mb-0"
                                    />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Дата рождения
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.birthday.from"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="от" />
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.birthday.to"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="до" />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Статус клиента
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8"
                                    class="mt-1 d-flex align-items-center">
                                    <CSelect
                                        :value.sync="filter.status"
                                        :horizontal="true"
                                        :options="customerStatusOptions"
                                        placeholder="Выберите статус"
                                        class="custom-filter-select w-full mb-0"
                                    />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Средний чек пользователя (за последние 30 дней с сегодняшней даты)
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <CInput
                                        v-model="filter.average_receipt.from"
                                        placeholder="от"
                                        class="mb-0 w-full"/>
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <CInput
                                        v-model="filter.average_receipt.to"
                                        placeholder="до"
                                        class="mb-0 w-full"/>
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Частота заказов пользователя (за последние 30 дней с сегодняшней даты)
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8"
                                    class="mt-1 d-flex align-items-center">
                                    <CSelect
                                        :value.sync="filter.orders_frequency"
                                        :horizontal="true"
                                        :options="ordersFrequencyOptions"
                                        placeholder="Выберите частоту заказов"
                                        class="custom-filter-select w-full mb-0"
                                    />
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>

                    <!-- Фильтры по заказам пользователя -->
                    <CCard class="mt-4">
                        <CCardBody>
                            <div class="mt-2">
                                <b>Фильтры по заказам пользователя</b>
                            </div>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Период совершения заказов
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.orders_period.from"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="от" />
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.orders_period.to"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="до" />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Пользователь заказывал
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8" 
                                    class="mt-1 d-flex align-items-center">
                                    <multiselect
                                        v-model="filter.service_types"
                                        :options="filterOptions.service_types"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="из сервиса"
                                        track-by="value"
                                        class="w-full" />
                                </CCol>
                            </CRow>
                            <CRow class="mt-2">
                                <CCol cols="12" md="4"></CCol>
                                <CCol cols="12" md="8" class="d-flex align-items-center">
                                    <span class="mr-2 text-muted logic-label">Логика со следующим условием:</span>
                                    <CButton
                                        size="sm"
                                        :color="filter.orders_filters_logic.service_types === 'and' ? 'primary' : 'light'"
                                        class="mr-1"
                                        @click="setOrdersFilterLogic('service_types', 'and')">
                                        И
                                    </CButton>
                                    <CButton
                                        size="sm"
                                        :color="filter.orders_filters_logic.service_types === 'or' ? 'danger' : 'light'"
                                        @click="setOrdersFilterLogic('service_types', 'or')">
                                        ИЛИ
                                    </CButton>
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Пользователь заказывал в башню
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8"
                                    class="mt-1 d-flex align-items-center">
                                    <multiselect
                                        v-model="filter.tower"
                                        :options="filterOptions.towers"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="выберите башню"
                                        track-by="value"
                                        class="w-full" />
                                </CCol>
                            </CRow>
                            <CRow class="mt-2">
                                <CCol cols="12" md="4"></CCol>
                                <CCol cols="12" md="8" class="d-flex align-items-center">
                                    <span class="mr-2 text-muted logic-label">Логика со следующим условием:</span>
                                    <CButton
                                        size="sm"
                                        :color="filter.orders_filters_logic.tower === 'and' ? 'primary' : 'light'"
                                        class="mr-1"
                                        @click="setOrdersFilterLogic('tower', 'and')">
                                        И
                                    </CButton>
                                    <CButton
                                        size="sm"
                                        :color="filter.orders_filters_logic.tower === 'or' ? 'danger' : 'light'"
                                        @click="setOrdersFilterLogic('tower', 'or')">
                                        ИЛИ
                                    </CButton>
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Пользователь заказывал из всех перечисленных
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8" 
                                    class="mt-1">
                                    <multiselect
                                        v-model="filter.services.restaurant"
                                        :options="filterOptions.restaurants"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="ресторанов"
                                        track-by="value"
                                        class="w-full mt-1" />
                                    <multiselect
                                        v-model="filter.services.grocer"
                                        :options="filterOptions.grocers"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="магазинов"
                                        track-by="value"
                                        class="w-full mt-1" />
                                    <multiselect
                                        v-model="filter.services.entity"
                                        :options="filterOptions.entities"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="сервисов"
                                        track-by="value"
                                        class="w-full mt-1" />
                                </CCol>
                            </CRow>
                            <CRow class="mt-2">
                                <CCol cols="12" md="4"></CCol>
                                <CCol cols="12" md="8" class="d-flex align-items-center">
                                    <span class="mr-2 text-muted logic-label">Логика со следующим условием:</span>
                                    <CButton
                                        size="sm"
                                        :color="filter.orders_filters_logic.services === 'and' ? 'primary' : 'light'"
                                        class="mr-1"
                                        @click="setOrdersFilterLogic('services', 'and')">
                                        И
                                    </CButton>
                                    <CButton
                                        size="sm"
                                        :color="filter.orders_filters_logic.services === 'or' ? 'danger' : 'light'"
                                        @click="setOrdersFilterLogic('services', 'or')">
                                        ИЛИ
                                    </CButton>
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Пользователь заказывал кухни
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8" 
                                    class="mt-1 d-flex align-items-center">
                                    <multiselect
                                        v-model="filter.cuisine_types"
                                        :options="cuisineTypeOptions"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Выберите типы кухни"
                                        track-by="value"
                                        class="w-full" />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Выбор поручения
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8" 
                                    class="mt-1 d-flex align-items-center">
                                    <multiselect
                                        v-model="filter.task_types"
                                        :options="taskTypeOptions"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Выберите типы поручений"
                                        track-by="value"
                                        class="w-full" />
                                </CCol>
                            </CRow>
                            <CRow class="mt-2">
                                <CCol cols="12" md="4"></CCol>
                                <CCol cols="12" md="8" class="d-flex align-items-center">
                                    <span class="mr-2 text-muted logic-label">Логика со следующим условием:</span>
                                    <CButton
                                        size="sm"
                                        :color="filter.orders_filters_logic.task_types === 'and' ? 'primary' : 'light'"
                                        class="mr-1"
                                        @click="setOrdersFilterLogic('task_types', 'and')">
                                        И
                                    </CButton>
                                    <CButton
                                        size="sm"
                                        :color="filter.orders_filters_logic.task_types === 'or' ? 'danger' : 'light'"
                                        @click="setOrdersFilterLogic('task_types', 'or')">
                                        ИЛИ
                                    </CButton>
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Фильтр по количеству заказов
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8" 
                                    class="mt-1">
                                    <CRow class="mt-1">
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1">
                                            <div class="d-flex align-items-center">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="filter.orders_count.apply"/>
                                                <span class="ml-2">Количество всех заказов</span>
                                            </div>
                                        </CCol>
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1"
                                            v-show="filter.orders_count.apply">
                                            <span class="d-flex align-items-center">
                                                <CInput 
                                                    v-model="filter.orders_count.from" 
                                                    placeholder="от"
                                                    class="mb-0" />
                                                <span class="ml-2">-</span>
                                                <CInput 
                                                    v-model="filter.orders_count.to" 
                                                    placeholder="до"
                                                    class="ml-2 mb-0" />
                                            </span>
                                        </CCol>
                                    </CRow>
                                    <hr class="mt-2">
                                    <CRow class="mt-1">
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1">
                                            <div class="d-flex align-items-center">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="filter.orders_rd_count.apply"/>
                                                <span class="ml-2">Количество заказов (рестораны)</span>
                                            </div>
                                        </CCol>
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1"
                                            v-show="filter.orders_rd_count.apply">
                                            <span class="d-flex align-items-center">
                                                <CInput 
                                                    v-model="filter.orders_rd_count.from"
                                                    placeholder="от"
                                                    class="mb-0" />
                                                <span class="ml-2">-</span>
                                                <CInput 
                                                    v-model="filter.orders_rd_count.to"
                                                    placeholder="до"
                                                    class="ml-2 mb-0" />
                                            </span>
                                        </CCol>
                                    </CRow>
                                    <hr class="mt-2">
                                    <CRow class="mt-1">
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1">
                                            <div class="d-flex align-items-center">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="filter.orders_gd_count.apply"/>
                                                <span class="ml-2">Количество заказов (магазины)</span>
                                            </div>
                                        </CCol>
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1"
                                            v-show="filter.orders_gd_count.apply">
                                            <span class="d-flex align-items-center">
                                                <CInput 
                                                    v-model="filter.orders_gd_count.from"
                                                    placeholder="от"
                                                    class="mb-0" />
                                                <span class="ml-2">-</span>
                                                <CInput 
                                                    v-model="filter.orders_gd_count.to"
                                                    placeholder="до"
                                                    class="ml-2 mb-0" />
                                            </span>
                                        </CCol>
                                    </CRow>
                                    <hr class="mt-2">
                                    <CRow class="mt-1">
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1">
                                            <div class="d-flex align-items-center">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="filter.orders_ed_count.apply"/>
                                                <span class="ml-2">Количество заказов (сервисы)</span>
                                            </div>
                                        </CCol>
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1"
                                            v-show="filter.orders_ed_count.apply">
                                            <div class="w-full mb-1">
                                                <CSelect 
                                                    v-model="filter.orders_ed_count.entity"
                                                    :options="filterOptions.entity_types"
                                                    placeholder="Тип сервиса"
                                                    class="custom-filter-select w-full mb-0">
                                                </CSelect>
                                            </div>
                                            <span class="mt-1 d-flex align-items-center">
                                                <CInput 
                                                    v-model="filter.orders_ed_count.from"
                                                    placeholder="от"
                                                    class="mb-0" />
                                                <span class="ml-2">-</span>
                                                <CInput 
                                                    v-model="filter.orders_ed_count.to"
                                                    placeholder="до"
                                                    class="ml-2 mb-0" />
                                            </span>
                                        </CCol>
                                    </CRow>
                                    <hr class="mt-2">
                                    <CRow class="mt-1">
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1">
                                            <div class="d-flex align-items-center">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="filter.orders_promotion_count.apply"/>
                                                <span class="ml-2">Количество заказов со скидками</span>
                                            </div>
                                        </CCol>
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1"
                                            v-show="filter.orders_promotion_count.apply">
                                            <span class="d-flex align-items-center">
                                                <CInput 
                                                    v-model="filter.orders_promotion_count.from"
                                                    placeholder="от"
                                                    class="mb-0" />
                                                <span class="ml-2">-</span>
                                                <CInput 
                                                    v-model="filter.orders_promotion_count.to"
                                                    placeholder="до"
                                                    class="ml-2 mb-0" />
                                            </span>
                                        </CCol>
                                    </CRow>
                                    <hr class="mt-2">
                                    <CRow class="mt-1">
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1">
                                            <div class="d-flex align-items-center">
                                                <CSwitch
                                                    color="dark"
                                                    shape="pill"
                                                    variant="opposite"
                                                    :checked.sync="filter.orders_promocode_count.apply"/>
                                                <span class="ml-2">Количество заказов с промокодами</span>
                                            </div>
                                        </CCol>
                                        <CCol
                                            cols="12"
                                            md="6"
                                            class="mt-1"
                                            v-show="filter.orders_promocode_count.apply">
                                            <span class="d-flex align-items-center">
                                                <CInput 
                                                    v-model="filter.orders_promocode_count.from"
                                                    placeholder="от"
                                                    class="mb-0" />
                                                <span class="ml-2">-</span>
                                                <CInput 
                                                    v-model="filter.orders_promocode_count.to"
                                                    placeholder="до"
                                                    class="ml-2 mb-0" />
                                            </span>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>

                    <!-- Исключающие фильтры -->
                    <CCard class="mt-4">
                        <CCardBody>
                            <div class="mt-2">
                                <b>Исключить из выборки пользователей</b>
                            </div>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Период совершения заказов
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.exclude.orders_period.from"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="от" />
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.exclude.orders_period.to"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="до" />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Дата регистрации пользователя
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.exclude.created_at.from"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="от" />
                                </CCol>
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    <DatePicker
                                        v-model="filter.exclude.created_at.to"
                                        :language="datepicker.lang"
                                        :format="datepicker.format"
                                        :clear-button="true"
                                        class="w-full"
                                        input-class="form-control custom-datepicker"
                                        placeholder="до" />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Пользователь заказывал из
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8" 
                                    class="mt-1">
                                    <multiselect
                                        v-model="filter.exclude.services.restaurant"
                                        :options="filterOptions.restaurants"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="ресторанов"
                                        track-by="value"
                                        class="w-full mt-1" />
                                    <multiselect
                                        v-model="filter.exclude.services.grocer"
                                        :options="filterOptions.grocers"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="магазинов"
                                        track-by="value"
                                        class="w-full mt-1" />
                                    <multiselect
                                        v-model="filter.exclude.services.entity"
                                        :options="filterOptions.entities"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="сервисов"
                                        track-by="value"
                                        class="w-full mt-1" />
                                </CCol>
                            </CRow>
                            <hr class="mt-2">
                            <CRow class="mt-1">
                                <CCol
                                    cols="12"
                                    md="4"
                                    class="mt-1 d-flex align-items-center">
                                    Пользователь заказывал кухни
                                </CCol>
                                <CCol 
                                    cols="12" 
                                    md="8" 
                                    class="mt-1 d-flex align-items-center">
                                    <multiselect
                                        v-model="filter.exclude.cuisine_types"
                                        :options="cuisineTypeOptions"
                                        label="label"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Выберите типы кухни"
                                        track-by="value"
                                        class="w-full" />
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>

                    <CRow class="mt-3">
                        <CCol cols="12" md="6">
                            <CButton
                                v-if="useFilter"
                                color="primary"
                                @click="applyFilters">Применить</CButton>
                            <!-- <CButton
                                v-if="adminOnly"
                                class="ml-2"
                                color="primary"
                                @click="$emit('do-export', filter)">Экспорт</CButton> -->
                            <CButton
                                v-if="useFilter"
                                class="ml-2"
                                color="secondary"
                                @click="resetFilters">Сбросить</CButton>
                        </CCol>
                        <CCol cols="12" md="6" class="text-right">
                            <CButton
                                :disabled="!(useFilter && filterCount > 0 && filtersApplied)"
                                class="ml-2"
                                color="success"
                                @click="openSaveSegmentModal">Сохранить как сегмент</CButton>
                            <br><br>
                        </CCol>
                    </CRow>
                </template>
                <br>
                <span class="ml-2">Всего: <strong>{{ this.filterCount }}</strong></span>
            </CCardBody>
        </CCard>
        <!-- <CRow>
            <CCol cols="12" md="6">
                <div v-if="useSorter">
                    <CSelect
                        class="mb-3"
                        label="Сортировка: "
                        horizontal
                        placeholder="Выберите..."
                        :value.sync="sorter"
                        :options="sorterOptions"
                        :change="$emit('set-sorter', sorter)"
                        v-if="useSorter"
                    />
                    <CButton
                        v-if="useSorter"
                        color="secondary"
                        class="mb-3"
                        @click="resetSorter"
                        >Сбросить</CButton
                    >
                </div>
            </CCol>
            <CCol cols="12" md="6" class="text-right">
                <CButton
                    color="info"
                    @click="openSettingsModal"
                    class="mb-2 mr-2"
                    >Выбрать колонки</CButton
                >
            </CCol>
        </CRow> -->

        <div class="table__preloader" v-if="loading">
            <CSpinner color="primary"/>
        </div>
        <div v-show="!loading">
            <CDataTable
                class="customers"
                hover
                :items="list"
                :fields="fields">
                <template #id="data">
                    <td>
                        <CLink :to="`/customers/${data.item.id}`">{{
                            data.item.id
                        }}</CLink>
                    </td>
                </template>
                <template #phone="data">
                    <td>
                        <CLink :to="`/customers/${data.item.id}`" class="flex align-items-center" :class="{'text-danger': data.item.deleted}">
                            {{ data.item.phone}} <CIcon v-if="data.item.deleted" :content="$options.icons.cilX" class="handle" />
                        </CLink>
                    </td>
                </template>
                <template #firstname="data">
                    <td>
                        <CLink :to="`/customers/${data.item.id}`">{{
                            data.item.firstname
                        }}</CLink>
                    </td>
                </template>
                <template #lastname="data">
                    <td>
                        <CLink :to="`/customers/${data.item.id}`">{{
                            data.item.lastname
                        }}</CLink>
                    </td>
                </template>
                <template #gender="data">
                    <td>
                        {{ genders[data.item.gender] }}
                    </td>
                </template>
                <template #created_at="data">
                    <td>
                        {{ formatDate(data.item.created_at) }}
                    </td>
                </template>
                <template #version_app="data">
                    <td>
                        {{ data.item.version_app ? version(data.item.version_app) : '' }}
                    </td>
                </template>
                <template #confirmed="data">
                    <td>
                        <CBadge :color="getBadge(data.item.confirmed)">&nbsp;{{
                            data.item.confirmed ? "Да" : "Нет"
                        }}&nbsp;</CBadge>
                    </td>
                </template>
                <template #enabled="data">
                    <td>
                        <CBadge :color="getBadge(data.item.enabled)">&nbsp;{{
                            data.item.enabled ? "Да" : "Нет"
                        }}&nbsp;</CBadge>
                    </td>
                </template>
                <template #adult="data">
                    <td>
                        <CBadge :color="getBadge(data.item.adult)">&nbsp;{{
                            data.item.adult ? "Да" : "Нет"
                        }}&nbsp;</CBadge>
                    </td>
                </template>
                <template #orders_rd_count="data">
                    <td>
                        {{ +data.item.orders_rd_count }}
                    </td>
                </template>
                <template #orders_gd_count="data">
                    <td>
                        {{ +data.item.orders_gd_count }}
                    </td>
                </template>
                <template #orders_ed_count="data">
                    <td>
                        {{ +data.item.orders_ed_count }}
                    </td>
                </template>
                <template #last_order_date="data">
                    <td>
                        {{ data.item.last_order_date ? formatDate(data.item.last_order_date) : '-' }}
                    </td>
                </template>
                <template #tower="data">
                    <td>
                        {{ data.item.tower ? getTowerTitle(data.item.tower) : '' }}
                    </td>
                </template>
                <template #status="data">
                    <td>
                        <CBadge v-if="data.item.status" :color="getCustomerStatusBadge(data.item.status)">
                            {{ getCustomerStatusText(data.item.status) }}
                        </CBadge>
                    </td>
                </template>
                <template #orders_frequency="data">
                    <td>
                        {{ data.item.orders_frequency ? getOrdersFrequencyText(data.item.orders_frequency) : '' }}
                    </td>
                </template>
                <template #average_receipt="data">
                    <td>
                        {{ data.item.average_receipt ? data.item.average_receipt + ' ₽' : '0 ₽' }}
                    </td>
                </template>
            </CDataTable>
        </div>

        <CModal
            title="Настройки отображения"
            :show.sync="settingsModal"
            :footer="true"
            color="info">
            <template>
                <div slot="header">Настройки отображения</div>
                <div slot="body-wrapper" class="modal-body">
                    <CRow v-for="field in fieldsAll" :key="field.key">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">
                            {{ field.label }}
                        </CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="fieldsSettings[field.key]" />
                        </CCol>
                    </CRow>
                </div>
                <div slot="footer">
                    <CButton color="primary" @click="closeSettingsModal">Сохранить</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            title="Сохранить как сегмент"
            :show.sync="saveSegmentModal.show"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p class="mb-3">
                        Будет создан сегмент с <b>{{ filterCount }}</b> клиентами на основе текущих фильтров.
                    </p>
                    <CRow class="mt-3">
                        <CCol cols="12">
                            <CInput
                                v-model="saveSegmentModal.name"
                                placeholder="Введите название сегмента"
                                class="mb-0"
                                :invalid="saveSegmentModal.nameError"
                            />
                            <div v-if="saveSegmentModal.nameError" class="invalid-feedback d-block">
                                Название сегмента обязательно для заполнения
                            </div>
                        </CCol>
                    </CRow>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="closeSaveSegmentModal">Отмена</CButton>
                    <CButton
                        color="success"
                        class="ml-3"
                        :disabled="saveSegmentModal.saving"
                        @click="saveSegment">
                        {{ saveSegmentModal.saving ? 'Сохранение...' : 'Сохранить' }}
                    </CButton>
                </div>
            </template>
        </CModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    require('moment-countdown');
    const { formatDate } = require('../utils/views');
    import { cilCursorMove, cilX } from '@coreui/icons';
    import { ORDER_TYPE } from '../utils/order'
    import Multiselect from 'vue-multiselect';
    import { isAuthorized } from '../utils/role';
    import { CUSTOMER_STATUS, ORDERS_FREQUENCY, getCustomerStatusText, getCustomerStatusBadge, getOrdersFrequencyText } from '../utils/customer';
    const {
        orderTypeTitle,
    } = require('../utils/order-views');

    export default {
        components: {
            Multiselect,
            DatePicker,
        },

        icons: {
            cilCursorMove,
            cilX
        },

        filters: {
            customerStatusText(status) {
                return getCustomerStatusText(status);
            },
            ordersFrequencyText(frequency) {
                return getOrdersFrequencyText(frequency);
            }
        },

        props: {
            list: {
                type: Array,
                default: () => [],
            },
            orderType: {
                type: String,
                default: 'all',
            },
            useFilter: {
                type: Boolean,
                default: false,
            },
            useSorter: {
                type: Boolean,
                default: false,
            },
            filterCount: {
                type: Number,
                default: 0,
            },
        },

        data() {
            return {
                isAuthorized: false,
                loading: true,
                fieldsAll: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'phone', label: 'Телефон' },
                    { key: 'firstname', label: 'Имя' },
                    { key: 'confirmed', label: 'Подтвержден' },
                    { key: 'enabled', label: 'Активен' },
                    { key: 'tower', label: 'Башня' },
                    { key: 'adult', label: '18+' },
                    { key: 'gender', label: 'Пол' },
                    { key: 'created_at', label: 'Дата регистрации' },
                    { key: 'status', label: 'Статус' },
                    { key: 'average_receipt', label: 'Средний чек' },
                    { key: 'orders_frequency', label: 'Частота заказов' },
                    { key: 'orders_count', label: 'Заказы' },
                    { key: 'orders_rd_count', label: 'Заказы рестораны' },
                    { key: 'orders_gd_count', label: 'Заказы магазины' },
                    { key: 'orders_ed_count', label: 'Заказы сервисы' },
                    { key: 'last_order_date', label: 'Последний заказ' },
                ],
                // Fields
                fieldsSettings: {},
                settingsModal: false,
                // Sorter
                sorter: '',
                sorterOptions: [
                    { value: '', label: 'Выберите...' },
                    { value: 'id-asc', label: 'ID: по возрастанию' },
                    { value: 'id-desc', label: 'ID: по убыванию' },
                    { value: 'created_at-asc', label: 'Дата регистрации: по возрастанию' },
                    { value: 'created_at-desc', label: 'Дата регистрации: по убыванию' },
                    { value: 'updated_at-asc', label: 'Обновлен: по возрастанию' },
                    { value: 'updated_at-desc', label: 'Обновлен: по убыванию' },
                    {
                        value: 'delivery_time-asc',
                        label: 'Доставка: по возрастанию',
                    },
                    { value: 'delivery_time-desc', label: 'Доставка: по убыванию' },
                    { value: 'price-asc', label: 'Цена: по возрастанию' },
                    { value: 'price-desc', label: 'Цена: по убыванию' },
                ],
                // Filters
                showFilters: false,
                genders: {
                    0: 'Не выбрано',
                    1: 'Мужской',
                    2: 'Женский'
                },
                filter: {
                    phone: '',
                    orders_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_rd_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_gd_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_ed_count: {
                        apply:false,
                        from: null,
                        to: null,
                        entity: '',
                    },
                    orders_promotion_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_promocode_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    gender: null,
                    created_at: {
                        from: '',
                        to: '',
                    },
                    last_visit: {
                        from: null,
                        to: null,
                    },
                    version_app: {
                        from: '',
                        to: '',
                    },
                    deleted: false,
                    service_types: [],
                    services: {
                        restaurant: '',
                        grocer: '',
                        entity: '',
                    },
                    tower: [],
                    status: null,
                    birthday: {
                        from: null,
                        to: null,
                    },
                    average_receipt: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_frequency: null,
                    orders_period: {
                        from: null,
                        to: null,
                    },
                    order_categories: [],
                    cuisine_types: [],
                    task_types: [],
                    orders_filters_logic: {
                        service_types: 'and',
                        tower: 'and',
                        services: 'and',
                        task_types: 'and',
                    },

                    exclude: {
                        orders_period: {
                            from: null,
                            to: null,
                        },
                        created_at: {
                            from: '',
                            to: '',
                        },
                        services: {
                            restaurant: '',
                            grocer: '',
                            entity: '',
                        },
                        cuisine_types: [],
                    }
                },
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                filterOptions: {
                    towers: [],
                    entity_types: [],
                    service_types: [],
                    restaurants: [],
                    grocers: [],
                    entities: [],
                },
                genderOptions: [
                    { value: null, label: 'Не выбрано' },
                    { value: 1, label: 'Мужской' },
                    { value: 2, label: 'Женский' },
                ],
                orderCategoryOptions: [
                    { value: 'restaurants', label: 'Рестораны' },
                    { value: 'grocers', label: 'Магазины' },
                    { value: 'pharmacy', label: 'Аптеки' },
                    { value: 'laundry', label: 'Химчистка' },
                    { value: 'flowers', label: 'Цветы' },
                    { value: 'assistant', label: 'Выполним поручение' },
                    { value: 'other', label: 'Прочее' },
                ],
                cuisineTypeOptions: [],
                taskTypeOptions: [],
                communicationMethodOptions: [
                    { value: 'PUSH', label: 'Push-уведомления' },
                    { value: 'TELEGRAM', label: 'Telegram' },
                    { value: 'WHATSAPP', label: 'WhatsApp' },
                    { value: 'EMAIL', label: 'Email' },
                ],
                ordersFrequencyOptions: [
                    { value: null, label: 'Не выбрано' },
                    { value: ORDERS_FREQUENCY.WEEKLY_0, label: `${getOrdersFrequencyText(ORDERS_FREQUENCY.WEEKLY_0)}` },
                    { value: ORDERS_FREQUENCY.WEEKLY_1, label: `${getOrdersFrequencyText(ORDERS_FREQUENCY.WEEKLY_1)}` },
                    { value: ORDERS_FREQUENCY.WEEKLY_2_3, label: `${getOrdersFrequencyText(ORDERS_FREQUENCY.WEEKLY_2_3)}` },
                    { value: ORDERS_FREQUENCY.WEEKLY_4_PLUS, label: `${getOrdersFrequencyText(ORDERS_FREQUENCY.WEEKLY_4_PLUS)}` },
                ],
                customerStatusOptions: [
                    { value: null, label: 'Не выбрано' },
                    { value: CUSTOMER_STATUS.NEW, label: getCustomerStatusText(CUSTOMER_STATUS.NEW) },
                    { value: CUSTOMER_STATUS.GOLD, label: getCustomerStatusText(CUSTOMER_STATUS.GOLD) },
                    { value: CUSTOMER_STATUS.SILVER, label: getCustomerStatusText(CUSTOMER_STATUS.SILVER) },
                    { value: CUSTOMER_STATUS.NEUTRAL, label: getCustomerStatusText(CUSTOMER_STATUS.NEUTRAL) },
                    { value: CUSTOMER_STATUS.SLEEPING, label: getCustomerStatusText(CUSTOMER_STATUS.SLEEPING) },
                    { value: CUSTOMER_STATUS.CHURNED, label: getCustomerStatusText(CUSTOMER_STATUS.CHURNED) },
                ],
                saveSegmentModal: {
                    show: false,
                    name: '',
                    nameError: false,
                    saving: false,
                },
                filtersApplied: false,
            };
        },

        computed: {
            fields() {
                const result = [];
                for (const item of this.fieldsAll) {
                    if (item.key === 'type') {
                        if (this.orderType === 'all') {
                            if (this.fieldsSettings[item.key]) {
                                result.push(item);
                            }
                        }
                    } else {
                        if (this.fieldsSettings[item.key]) {
                            result.push(item);
                        }
                    }
                }
                return result;
            },
            adminOnly() {
                return 
                    process.env.VUE_APP_MAIN_ADMIN_EMAILS.indexOf(JSON.parse(localStorage.getItem('profile')).email) >= 0  
                    && this.useFilter 
                    && this.isAuthorized;
            },
        },

        async created() {
            this.filterOptions = await this.getFilterOptions();
            this.cuisineTypeOptions = await this.getCuisineTypes();
            this.taskTypeOptions = await this.getTaskTypes();
            this.fieldsSettings = this.getFildsSettings();
            this.loading = false;

            this.isAuthorized = isAuthorized(['super_admin']);
        },

        methods: {
            orderTypeTitle(orderTypeId, item = {}) {
                if (orderTypeId === ORDER_TYPE.ASSISTANT_HELP) {
                    return 'ПМ';
                }
                if (orderTypeId === ORDER_TYPE.ENTITY_DELIVERY && item?.ed?.items) {
                    const { entity } = item.ed.items[0];
                    return entity.entityType.title.charAt(0);
                }
                return orderTypeTitle(orderTypeId).charAt(0);
            },
            getCustomerStatusText,
            getCustomerStatusBadge,
            getOrdersFrequencyText,
            async getTypes() {
                const options = [];
                options.push({ value: '', label: 'Выберите...' });
                for (const type of [ORDER_TYPE.RESTAURANT_DELIVERY, ORDER_TYPE.GROCER_DELIVERY]) {
                    options.push({
                        value: type,
                        label: orderTypeTitle(type),
                    });
                }
                const entities = await Vue.axios.get('/entities-type/');
                entities.data.forEach(entity => {
                    const condidate = options.findIndex(filter => filter.value === entity.code);
                    if (condidate === -1) {
                        options.push({
                            value: entity.code,
                            label: entity.title,
                        })
                    } else {
                        options.splice(condidate, 1, {
                            value: entity.code,
                            label: entity.title,
                        });
                    }
                })
                return options.filter(filter => filter.value !== ORDER_TYPE.ENTITY_DELIVERY);
            },
            version(version_val) {
                let str = String(version_val);
                
                let major = str.substring(0, 1);
                let minor = str.substring(1, 4).replace(/^[0]+/, "") || "0";
                let patch = str.substring(4, 7).replace(/^[0]+/, "") || "0";
                let newStr = [major, minor, patch].join(".");

                return newStr;
            },
            async getFilterOptions() {
                return {
                    service_types:  await this.getTypes(),
                    towers: await this.getTowers(),
                    entity_types: await this.getEntityTypes(),
                    restaurants: await this.getRestaurants(),
                    grocers: await this.getGrocers(),
                    entities: this.filterOptions.entities,
                };
            },
            getTowerTitle(id) {
                let tower;
                for (const iterator of this.filterOptions.towers) {
                    if(iterator.value === id) {
                        tower = iterator.label
                    }
                }

                return tower;
            },
            async getTowers() {
                const options = [];
                options.push({ value: '', label: 'Выберите башню...' });
                const result = await Vue.axios.get('/address');
                result.data.forEach(item => {
                    options.push({ value: item.id, label: item.name });
                });
                return options;
            },

            async getEntityTypes() {
                const options = [];
                options.push({ value: '', code: '', label: 'Выберите тип...' });
                const result = await Vue.axios.get('/entities-type');
                result.data.forEach(item => {
                    options.push({ value: item.code, code: item.code, label: item.title });
                });

                const newServices = [];
                for (const type of options) {
                    if (type.code) {
                        const { data } = await Vue.axios.get('/entities/' + type.code);
                        data.forEach(ent => {
                            newServices.push({ id: ent.id, label: ent.title, code: ent.code, value: ent.id })
                        })
                    }
                }
                newServices.sort((a, b) => a.label > b.label ? 1 : -1);
                this.filterOptions.entities = newServices;

                return options;
            },
            async getRestaurants() {
                const options = [];
                options.push({ code: null, label: 'Ресторан..' });
                const { data } = await Vue.axios.get('/restaurants');
                data.forEach(rest => {
                    options.push({ value: rest.id, code: rest.id, label: rest.title });
                })
                options.sort((a, b) => a.label > b.label ? 1 : -1);
                return options;
            },
            async getGrocers() {
                const options = [];
                options.push({ code: null, label: 'Магазины..' });
                const { data } = await Vue.axios.get('/grocers');
                data.forEach(gr => {
                    options.push({ value: gr.id, code: gr.id, label: gr.title });
                })
                options.sort((a, b) => a.label > b.label ? 1 : -1);
                return options;
            },

            async getCuisineTypes() {
                const options = [];
                options.push({ value: null, label: 'Не выбрано' });
                try {
                    const { data } = await Vue.axios.get('/cuisine-types');
                    data.forEach(cuisine => {
                        options.push({ value: cuisine.id, label: cuisine.name });
                    });
                    options.sort((a, b) => a.label > b.label ? 1 : -1);
                } catch (error) {
                    console.error('Ошибка загрузки типов кухни:', error);
                }
                return options;
            },

            async getTaskTypes() {
                const options = [];
                options.push({ value: null, label: 'Не выбрано' });
                try {
                    const { data } = await Vue.axios.get('/entities-type');
                    data.forEach(entityType => {
                        if (entityType.analytics_data && entityType.analytics_data_values) {
                            entityType.analytics_data_values.forEach(item => {
                                options.push({ 
                                    value: item.title, 
                                    label: item.title 
                                });
                            });
                        }
                    });
                    // Удаляем дубликаты и сортируем
                    const uniqueOptions = options.filter((option, index, self) => 
                        index === self.findIndex(o => o.value === option.value)
                    );
                    uniqueOptions.sort((a, b) => {
                        if (a.value === null) return -1;
                        if (b.value === null) return 1;
                        return a.label > b.label ? 1 : -1;
                    });
                    return uniqueOptions;
                } catch (error) {
                    console.error('Ошибка загрузки типов поручений:', error);
                    return options;
                }
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            formatDate(ISOString) {
                return formatDate(ISOString);
            },
            // Fields settings
            getFildsSettings() {
                var fieldsSettings = JSON.parse(
                    localStorage.getItem('customers-table-settings')
                );
                if (!fieldsSettings) {
                    fieldsSettings = this.getDefaultFieldsSettings();
                }
                return fieldsSettings;
            },
            getDefaultFieldsSettings() {
                const result = {};
                for (const item of this.fieldsAll) {
                    result[item.key] = true;
                }
                return result;
            },
            setFieldsSettings(fieldsSettings) {
                localStorage.setItem(
                    'customers-table-settings',
                    JSON.stringify(fieldsSettings)
                );
            },
            openSettingsModal() {
                this.settingsModal = true;
            },
            closeSettingsModal() {
                this.setFieldsSettings(this.fieldsSettings);
                this.settingsModal = false;
                this.$forceUpdate();
            },
            resetSorter() {
                this.sorter = '';
            },
            resetFilters() {
                this.filter = {
                    phone: '',
                    orders_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_rd_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_gd_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_ed_count: {
                        apply:false,
                        from: null,
                        to: null,
                        entity: '',
                    },
                    orders_promotion_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_promocode_count: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    gender: null,
                    created_at: {
                        from: '',
                        to: '',
                    },
                    last_visit: {
                        from: null,
                        to: null,
                    },
                    version_app: {
                        from: '',
                        to: '',
                    },
                    deleted: false,
                    service_types: [],
                    services: {
                        restaurant: '',
                        grocer: '',
                        entity: '',
                    },
                    tower: [],
                    status: null,
                    birthday: {
                        from: null,
                        to: null,
                    },
                    average_receipt: {
                        apply: false,
                        from: null,
                        to: null,
                    },
                    orders_frequency: null,
                    orders_period: {
                        from: null,
                        to: null,
                    },
                    order_categories: [],
                    cuisine_types: [],
                    task_types: [],
                    orders_filters_logic: {
                        service_types: 'and',
                        tower: 'and',
                        services: 'and',
                        task_types: 'and',
                    },

                    exclude: {
                        orders_period: {
                            from: null,
                            to: null,
                        },
                        created_at: {
                            from: '',
                            to: '',
                        },
                        services: {
                            restaurant: '',
                            grocer: '',
                            entity: '',
                        },
                        cuisine_types: [],
                    }
                };
                this.showFilters = false;
                this.filtersApplied = false;

                this.$emit('set-filter', null);
            },
            openSaveSegmentModal() {
                this.saveSegmentModal.show = true;
            },
            closeSaveSegmentModal() {
                this.saveSegmentModal.show = false;
                this.saveSegmentModal.name = '';
                this.saveSegmentModal.nameError = false;
            },
            async saveSegment() {
                if (!this.saveSegmentModal.name) {
                    this.saveSegmentModal.nameError = true;
                    return;
                }
                
                this.saveSegmentModal.nameError = false;
                this.saveSegmentModal.saving = true;
                
                try {
                    await Vue.axios.post('/customers/save-as-segment', {
                        name: this.saveSegmentModal.name,
                        filters: this.filter
                    });
                    
                    this.$root.$emit('showSuccess', `Сегмент "${this.saveSegmentModal.name}" успешно создан!`);
                    this.closeSaveSegmentModal();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка при создании сегмента.');
                    console.error(err);
                } finally {
                    this.saveSegmentModal.saving = false;
                }
            },
            applyFilters() {
                this.filtersApplied = true;
                this.$emit('set-filter', this.filter);
            },
            setOrdersFilterLogic(filterKey, logicMode) {
                if (logicMode !== 'and' && logicMode !== 'or') {
                    return;
                }

                this.$set(this.filter.orders_filters_logic, filterKey, logicMode);
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.status-cell span {
    display: block;
}
.custom-datepicker.form-control:disabled, .custom-datepicker.form-control[readonly] {
    background-color: #ffffff;
}
.custom-filter-select {
    margin: 0 !important;
}
.custom-filter-select .col-sm-9 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
}
.vdp-datepicker__clear-button {
    position: absolute;
    top: 0px;
    right: 10px;
    font-size: 20px;
}
.logic-label {
    font-size: 12px;
}
</style>
